<script setup lang="ts">
import type {
  ComponentBlockImageListCtaFragment,
  Enum_Componentblockimagelistcta_Variation,
} from "~~/types/graphql";

import Check from "@/assets/icons/check.svg?component";
import Arrow from "@/assets/icons/arrow.svg?component";

const props = defineProps<{
  ImageListCtaHeadline?: ComponentBlockImageListCtaFragment["ImageListCtaHeadline"];
  ImageListCtaText: ComponentBlockImageListCtaFragment["ImageListCtaText"];
  ImageListCtaImage?: ComponentBlockImageListCtaFragment["ImageListCtaImage"];
  ImageListCtaLink: ComponentBlockImageListCtaFragment["ImageListCtaLink"];
  ImageListCtaLinkText: ComponentBlockImageListCtaFragment["ImageListCtaLinkText"];
  ImageListCtaVariation: Enum_Componentblockimagelistcta_Variation;
  outerSpace?: boolean;
}>();

const items = props.ImageListCtaText
  ? props.ImageListCtaText.split("- ").filter((item) => item !== "")
  : [];
</script>

<template>
  <layout-block
    class="image-list-cta"
    :class="{
      'bg-integer-black text-integer-white':
        props.ImageListCtaVariation === 'dark',
      'bg-integer-white text-integer-black':
        props.ImageListCtaVariation === 'light',
    }"
    :outer-space="props.outerSpace ? props.outerSpace : true"
  >
    <div class="grid gap-10 md:grid-cols-12">
      <div
        v-if="props.ImageListCtaImage?.data?.attributes"
        class="md:col-start-1 md:col-end-6"
      >
        <base-image
          v-bind="props.ImageListCtaImage.data.attributes"
          sizes="(min-width: 768px) 40vw, (max-width: 767px) 100vw"
        />
      </div>
      <div
        class="flex flex-col md:col-end-12"
        :class="{
          'md:col-start-7': props.ImageListCtaImage?.data?.attributes,
          'md:col-start-1': !props.ImageListCtaImage?.data?.attributes,
        }"
      >
        <h2
          v-if="props.ImageListCtaHeadline"
          class="hyphens-auto font-pixel text-h2-s font-semibold sm:text-h2"
        >
          {{ props.ImageListCtaHeadline }}
        </h2>
        <ul>
          <li v-for="item in items" :key="`${item}`">
            <div
              v-if="item !== ''"
              class="listtext mt-3 grid gap-2 font-default text-default"
            >
              <Check class="mt-1 min-w-fit max-w-fit" />
              <div>{{ item }}</div>
            </div>
          </li>
        </ul>
        <base-button
          v-if="props.ImageListCtaLinkText"
          class="mr-auto mt-5.6 w-full justify-center xs:w-auto"
          :to="props.ImageListCtaLink"
          :type="
            props.ImageListCtaVariation === 'dark' ? 'primary' : 'secondary'
          "
          :transparent="true"
        >
          {{ props.ImageListCtaLinkText }}
          <template #icon-right>
            <Arrow />
          </template>
        </base-button>
      </div>
    </div>
  </layout-block>
</template>

<style scoped>
.listtext {
  display: grid;
  grid-template-columns: min-content 1fr;
}
</style>
